<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">理财系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>挖矿宝</el-breadcrumb-item>
            <el-breadcrumb-item>活期挖矿</el-breadcrumb-item>
        </el-breadcrumb>

        <el-input v-model="queryParams.coinType" placeholder="币种" style="width: 200px"></el-input>
        <el-button type="primary" @click="searchData" style="margin: 20px 0">搜 索</el-button>
        <el-button type="danger" @click="addMiningRegularDialog" style="margin: 20px 20px">增 加</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" fixed="left" label="ID"></el-table-column>
            <el-table-column prop="coinType" label="挖矿币种" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sort" label="优先级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="minAmount" label="最小存入数量"></el-table-column>
            <el-table-column prop="scale" label="小数位"></el-table-column>
            <el-table-column prop="status" label="上/下架" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.showed==0?false:true" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterStatus(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column prop="transferInStatus" label="转入状态">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.transferInStatus==0?false:true" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterTren(scope.row.id,$event)"    />
                </template>
            </el-table-column>

            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateDialog(scope.row)">编辑</el-button>
<!--                    <el-button type="danger" @click="deleteRegular(scope.row.id)">停用转入</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item  label="挖矿币种：" prop="coin" style="padding-top: 20px">
                    <el-autocomplete  :disabled="title=='修改'" class="inline-input" style="width: 500px"
                                     v-model="addData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanAddCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>


                </el-form-item>



                <el-form-item label="优先级：" prop="sort" style="padding-top: 20px">
                    <el-input v-model="addData.sort" placeholder="优先级(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>

                <el-form-item label="最小存入数量：" prop="sort" style="padding-top: 20px">
                    <el-input v-model="addData.minAmount" placeholder="最小存入数量(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>

                <el-form-item label="小数位：" prop="sort" style="padding-top: 20px">
                    <el-input v-model="addData.scale" placeholder="小数位(正整数：0＜X≤8)" style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addMiningRegular">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'Alive',
        data() {
            return {
                dataList: [],
                total: 0,
                coinTypes: [],
                queryParams: {
                    coinType: "",
                    page: 1,
                    size: 10
                },
                title: "新增",
                dialogVisible: false,
                loading: false,
                addData: {
                    id: "",
                    startTime: "",
                    endTime: "",
                    sort: "",
                    time: [],
                    coinType:"",
                    minAmount:"",
                    scale:"",
                    transferInStatus:"",
                    showed:"",

                },
                addRules: {
                    //"period": [{required: true, message: "请输入期数"}],
                  //  "time": [{required: true, message: "请输开始时间和结束时间"}],
                    "sort": [{required: true, message: "请输入优先级"}],
                },
                reg: /^[0-9]*$/,
            }
        },
        methods: {
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            searchData() {
                this.queryParams.page = 1;
                this.getMiningAliveList();
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coin = '';
            },
            cleanAddCoin() {
                this.addData.coin = '';
            },
            getMiningAliveList() {

                api.getMiningAliveList(this.queryParams).then(({data}) => {
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            addMiningRegular() {

                if (this.addData.sort != "" && !this.reg.test(this.addData.sort)) {
                    this.$message.error('优先级必须为整形数字!');
                    return;
                }
                this.addData.showed =0;
                this.addData.transferInStatus =0;
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        console.log(this.title)
                        if(this.title=='新增') {
                            this.loading = true;
                            api.createMiningAlive(this.addData).then(({data}) => {
                                this.$message.success('操作成功!');
                                this.loading = false;
                                this.dialogVisible = false;
                                this.getMiningAliveList();
                            });
                        }else if(this.title=='修改'){
                            this.loading = true;
                            api.updateMiningAlive(this.addData).then(({data}) => {
                                this.$message.success('操作成功!');
                                this.loading = false;
                                this.dialogVisible = false;
                                this.getMiningAliveList();
                            });
                        }
                        setTimeout(()=>{
                            this.loading = false;
                        },1000);
                    }
                });
            },
            addMiningRegularDialog() {
                this.title = "新增";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.addData =row
                this.title = "修改";
                this.dialogVisible = true;
            },


            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getMiningAliveList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getMiningAliveList();
            },

            alterStatus(id, status) {
                this.$confirm(status ? '确认上架吗？' : '确认下架吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateMiningAliveStatus({id: id,type:0, val: status?1:0}).then(() => {
                        this.$message.success('操作成功');
                        this.getMiningAliveList();
                    });
                }).catch(() => {
                });
            },
            alterTren(id, status) {
                this.$confirm(status ? '确认停用吗？' : '确认启用吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateMiningAliveStatus({id: id,type:1, val: status?1:0}).then(() => {
                        this.$message.success('操作成功');
                        this.getMiningAliveList();
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.title = "新增";
                this.addData = {
                    id: "",
                    period: "",
                    startTime: "",
                    endTime: "",
                    sort: "",
                    time: []
                }
            }
        },
        created() {
            this.getAllSupportCoin();
            this.getMiningAliveList();
        }
    };
</script>

<style lang="less" scoped>

</style>
